import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getSubscription } from '../services/supabase';
import { Loader2 } from 'lucide-react';
import { Subscription } from '../types';
import { supabase } from '../services/supabase';

interface RequireSubscriptionProps {
  children: React.ReactNode;
}

export const RequireSubscription: React.FC<RequireSubscriptionProps> = ({ children }) => {
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const fetchSub = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        setUserId(session.user.id);
        const sub = await getSubscription(session.user.id);
        setSubscription(sub as any);
      }
      setLoading(false);
    };

    fetchSub();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center p-20">
        <Loader2 className="animate-spin text-raizama-action" />
      </div>
    );
  }

  if (!userId) {
    return <Navigate to="/" />;
  }

  const isActive = subscription?.status === 'active' || subscription?.status === 'trialing';

  if (!isActive) {
    return <Navigate to="/plans" state={{ from: location }} />;
  }

  return <>{children}</>;
};
